import React, { useEffect, useState } from "react";
import "./HealthDashboard.css";

export default function VitalCard({
  title = "Vital",
  value = 0,
  unit = "",
  normalRange = "",
  lowRange = "",
  highRange = "",
  maxValue = 140
}) {
  const [displayValue, setDisplayValue] = useState(0);

  const isNumeric = (val) => typeof val === "number";

  useEffect(() => {
    if (!isNumeric(value)) {
      setDisplayValue(value);
      return;
    }

    let start = 0;
    const duration = 900;
    const step = 20;
    const inc = value / (duration / step);

    const timer = setInterval(() => {
      start += inc;

      if (start >= value) {
        setDisplayValue(value);
        clearInterval(timer);
      } else {
        setDisplayValue(Math.floor(start));
      }
    }, step);

    return () => clearInterval(timer);
  }, [value]);

  const getColor = () => {
    if (!isNumeric(value)) {
      const v = value?.toLowerCase?.();

      if (v === "low") return "#22c55e";
      if (v === "medium") return "#f59e0b";
      if (v === "high") return "#ef4444";

      return "#94a3b8";
    }

    if (lowRange && value < parseFloat(lowRange.replace(/[^\d]/g, "")))
      return "#ef4444";

    if (highRange && value > parseFloat(highRange.replace(/[^\d]/g, "")))
      return "#ef4444";

    return "#22c55e";
  };

  const percent = isNumeric(value)
    ? Math.min((value / maxValue) * 100, 100)
    : 100;

  return (
    <div className="vital-card">
      <div className="vital-title">{title}</div>

      <div className="vital-value" style={{ color: getColor() }}>
        {displayValue}
        <span className="unit">{unit}</span>
      </div>

      <div className="progress">
        <div
          className="progress-bar"
          style={{
            width: `${percent}%`,
            background: getColor()
          }}
        />
      </div>

      <div className="ranges">
        {normalRange && <span className="normal">{normalRange}</span>}
        {lowRange && <span className="low">{lowRange}</span>}
        {highRange && <span className="high">{highRange}</span>}
      </div>
    </div>
  );
}